import { Component, Input, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WidgetComponentSubType } from 'app/campaign/widgets.model';
import { Subscription } from 'rxjs';
import { FlyoutDataType, FlyoutOpeningData, PersonalData, SessionDetails } from '../flyout-models';
import { FlyoutService } from '../flyout.service';

@Component({
  selector: 'app-flyout-submitted-form',
  templateUrl: './flyout-submitted-form.component.html',
  styleUrls: ['./flyout-submitted-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class FlyoutSubmittedFormComponent implements OnInit, OnDestroy {
  private _openingData: FlyoutOpeningData;
  private sessionDetails: SessionDetails;
  private sessionSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public FlyoutDataTypes = FlyoutDataType;
  public personalData = undefined as PersonalData;
  public customProperties: any;
  public WidgetComponentSubType = WidgetComponentSubType;
  public objSubmittedForm = {};
  public arrSubmittedForm = [];
  public expandedTab: string;

  @Input() public set flyoutOpeningData(openingData: FlyoutOpeningData) {
    if (openingData) {
      this._openingData = openingData;
      this.expandedTab = this._openingData.expandedTab;
      this.processData();
    }
  }

  public get flyoutOpeningData(): FlyoutOpeningData {
    return this._openingData;
  }

  constructor(private readonly flyoutService: FlyoutService) {}

  ngOnInit() {
    this.sessionSubscription = this.flyoutService.sessionDetailsBS.subscribe((sessionDetails: SessionDetails) => {
      this.sessionDetails = sessionDetails;
      if (this.sessionDetails) {
        this.processData();
      }
    });
  }

  private processData(): void {
    this.customProperties = this.sessionDetails?.properties;
    this.personalData = this.sessionDetails?.personalData;

    this.arrSubmittedForm = this.flyoutOpeningData.dataSubmittedForm.displayedColumns
      .map((columnName) => {
        if (columnName === 'select' || columnName === 'createdDate') return;
        let value = this.flyoutOpeningData.dataSubmittedForm.dataSource[columnName];
        let originalValue;
        let total;
        let typeValue: string;
        const key = this.renameKey(
          this.flyoutOpeningData.dataSubmittedForm?.selectedResponseListColumns.find((item) => item.key === columnName)
            .type,
          columnName,
        );

        if (key === WidgetComponentSubType.ButtonListThumbRating) {
          if (this.customProperties && this.customProperties[columnName]) {
            originalValue = this.customProperties[columnName];
          } else {
            originalValue = this.flyoutOpeningData.dataSubmittedForm?.dataSource[columnName];
          }
        }
        if (key === WidgetComponentSubType.ButtonListStarRating) {
          total = this.flyoutOpeningData.dataSubmittedForm?.selectedResponseListColumns?.find(
            (item) => item.key === columnName,
          )?.inputDefinitions.length;
          value = this.flyoutOpeningData.dataSubmittedForm?.dataSource[columnName];
          if (value) {
            if (isNaN(Number(value))) {
              if (this.customProperties && this.customProperties[columnName]) {
                originalValue = Array.from({ length: this.customProperties[columnName] }, () =>
                  Number(this.customProperties[columnName]),
                );
                if (total) total = Array(total - this.customProperties[columnName]).fill(total);
              }
            } else {
              originalValue = Array.from({ length: value }, () => Number(value));
              if (total) total = Array(total - value).fill(total);
              value = '';
            }
          }
        }
        if (value && isNaN(Number(value))) {
          typeValue = 'string';
        } else if (value && !isNaN(Number(value))) {
          typeValue = 'number';
        }
        return {
          label: this.flyoutOpeningData.dataSubmittedForm.customNameMapper[columnName],
          value,
          key,
          originalValue,
          total,
          typeValue,
        };
      })
      .filter((item) => item);
  }

  public renameKey(name, key): string {
    if (
      name.includes('CsatStarRating') ||
      name.includes('StarRating') ||
      key.includes('CsatStarRating') ||
      key.includes('StarRating')
    ) {
      return WidgetComponentSubType.ButtonListStarRating;
    } else if (
      name.includes('ThumbRating') ||
      name.includes('CsatThumbRating') ||
      key.includes('ThumbRating') ||
      key.includes('CsatThumbRating')
    ) {
      return WidgetComponentSubType.ButtonListThumbRating;
    } else if (
      name.includes('CsatNumericalRating') ||
      name.includes('NPS') ||
      name.includes('NumericalRating') ||
      name.includes('NpsRating') ||
      key.includes('CsatNumericalRating') ||
      key.includes('NPS') ||
      key.includes('NpsRating') ||
      key.includes('NumericalRating')
    ) {
      return WidgetComponentSubType.ButtonListNpsRating;
    } else {
      return name;
    }
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.sessionSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
